/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Choose_A_JobInputs */

const en_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const de_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const fr_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const es_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const it_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const nl_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const pl_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const fi_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const da_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

const sv_negotiation_choose_a_job = /** @type {(inputs: Negotiation_Choose_A_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a job...`)
};

/**
* | output |
* | --- |
* | "Choose a job..." |
*
* @param {Negotiation_Choose_A_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_choose_a_job = /** @type {((inputs?: Negotiation_Choose_A_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Choose_A_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_choose_a_job(inputs)
	if (locale === "fr") return fr_negotiation_choose_a_job(inputs)
	if (locale === "es") return es_negotiation_choose_a_job(inputs)
	if (locale === "it") return it_negotiation_choose_a_job(inputs)
	if (locale === "nl") return nl_negotiation_choose_a_job(inputs)
	if (locale === "pl") return pl_negotiation_choose_a_job(inputs)
	if (locale === "fi") return fi_negotiation_choose_a_job(inputs)
	if (locale === "da") return da_negotiation_choose_a_job(inputs)
	if (locale === "sv") return sv_negotiation_choose_a_job(inputs)
	return en_negotiation_choose_a_job(inputs)
});